import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  label: 'Co.',
  id: 'about'
}, {
  label: 'House',
  id: 'how'
}, {
  label: 'Hosts',
  id: 'leaders'
}, {
  label: 'Locations',
  id: 'locations'
}];
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
    setOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-paper/90 backdrop-blur-md border-b border-ink/10' : 'bg-transparent'}`} data-id="element-165">
      <nav className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex items-center justify-between" data-id="element-166">
        <button onClick={() => scrollTo('top')} aria-label="Home" className="font-serif-display text-2xl text-ink tracking-tight" data-id="element-167">
          Co<span className="text-sun italic" data-id="element-168">.</span>
        </button>

        <ul className="hidden md:flex items-center gap-10" data-id="element-169">
          {links.map(l => <li key={l.id} data-id="element-170">
              <button onClick={() => scrollTo(l.id)} className="eyebrow !text-ink-soft hover:!text-ink transition-colors" data-id="element-171">
                {l.label}
              </button>
            </li>)}
        </ul>

        <button onClick={() => scrollTo('waitlist')} className="hidden md:inline-flex items-center px-5 py-2.5 bg-ink text-bone text-[10px] uppercase tracking-[0.32em] hover:bg-sun transition-colors duration-500" data-id="element-172">
          Waitlist
        </button>

        <button className="md:hidden text-ink" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-id="element-173">
          {open ? <XIcon size={20} data-id="element-174" /> : <MenuIcon size={20} data-id="element-175" />}
        </button>
      </nav>

      {open && <div className="md:hidden bg-paper border-t border-ink/10 px-6 py-8" data-id="element-176">
          <ul className="flex flex-col gap-6" data-id="element-177">
            {links.map(l => <li key={l.id} data-id="element-178">
                <button onClick={() => scrollTo(l.id)} className="eyebrow !text-ink" data-id="element-179">
                  {l.label}
                </button>
              </li>)}
            <li data-id="element-180">
              <button onClick={() => scrollTo('waitlist')} className="eyebrow !text-sun" data-id="element-181">
                Waitlist
              </button>
            </li>
          </ul>
        </div>}
    </header>;
}